import {
    FETCH_USER_PRODUCT_MEMBERSHIP_POOL,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOLS,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_FAILURE,
    FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_SUCCESS,
} from 'store/actions/types';

export const fetchUserProductMembershipPools = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_POOLS,
        payload,
    };
};

export const fetchUserProductMembershipPoolsFailure = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_FAILURE,
        payload,
    };
};

export const fetchUserProductMembershipPoolsSuccess = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_POOLS_SUCCESS,
        payload,
    };
};

export const fetchUserProductMembershipPool = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_POOL,
        payload,
    };
};

export const fetchUserProductMembershipPoolFailure = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
        payload,
    };
};

export const fetchUserProductMembershipPoolSuccess = (payload) => {
    return {
        type: FETCH_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
        payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/product-membership-pool/fetchUserProductMembershipPool.js